import { configureIguazuREST } from 'iguazu-rest';
import createTimeoutFetch from './createTimeoutFetch';
import resources from './resources';
import { getIguazuResourcesSelector } from '../selectors/selectors';

const config = () => {
  configureIguazuREST({
    baseFetch: createTimeoutFetch(30000),
    getToState: getIguazuResourcesSelector,
    resources,
    defaultOpts: {
      timeout: 30000, // 30s in ms
    },
  });
};

export default config;
